import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const FreeStartButton = ({ id, className = 'hm-button', children = 'Start pay as you go', onNavigate }) => <Link to="/signup?plan=launchpad" className={className} onClick={onNavigate} data-testid={id}>{children}<ArrowRight size={17} /></Link>;